import React, { createContext, useContext, useState } from 'react';

const HeaderContext = createContext();

export const useHeader = () => {
    const context = useContext(HeaderContext);
    if (!context) {
        throw new Error('useHeader must be used within HeaderProvider');
    }
    return context;
};

export const HeaderProvider = ({ children }) => {
    const [headerLeft, setHeaderLeft] = useState(null);

    return (
        <HeaderContext.Provider value={{ headerLeft, setHeaderLeft }}>
            {children}
        </HeaderContext.Provider>
    );
};
